<template>


    <app-layout :title="__('Calendar')">


        <div class="">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8">


                <div
                    style="grid-template-rows:  max-content minmax(200px, max-content);"
                    class="grid grid-cols-2">


                    <div class="my-4 row-start-1 flex items-center">


                        <h1 class="text-2xl font-nexa text-dark-blue"
                            style="height: 30px">

                            Calendar

                        </h1>


                        <div class=""
                             style="height: 22px">


                            <font-awesome-icon
                                class="ml-8 justify-center font-bold"
                                style="width: 16px; height: 16px; margin-top: 4px;"
                                size="sm"
                                :icon="['far', 'filter']" />


                            <filter-drop-down
                                :selected="selected_topic"
                                :choices="dropdown_topics"
                                @clicked_item="(choice) => { this.handle_click_dropdown('topic',choice) }"/>


                        </div>


                    </div>


                    <NordenTable
                        :headers="content_headers"
                        :rows="content"
                        @flag_clicked="handle_flag_clicked">

                        <template #published="props">

                            <div class="flex flex-col">

                                <p>{{ props.row.published }}</p>

                                <p class="text-xs">Import: {{ props.row.created_first }}</p>

                                <p class="text-xs">Last Resend: {{ props.row.last_resend_at }}</p>

                            </div>

                        </template>

                    </NordenTable>


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";
import FilterDropDown from "@/Components/FilterDropDown";

export default defineComponent({

    components: {
        FilterDropDown,
        NordenTable,
        AppLayout
    },

    props: {
        content_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        name: 'Image',
                        text_key: 'thumbnail',
                        type: 'image',
                        value_key: 'thumbnail',
                        column_width: '75px',
                        class: ''
                    },
                    {
                        name: 'Title',
                        text_key: 'name',
                        value_key: 'name',
                        column_width: 3.0,
                        class: 'truncate leading-[50px] min-h-[50px]',
                    },
                    {
                        type: 'slot',
                        name: 'Published',
                        text_key: 'published',
                        value_key: 'published',
                        column_width: '180px',
                        class: '',
                    },
                    {
                        name: 'Topics',
                        text_key: 'topic',
                        value_key: 'topic',
                        type: 'topics',
                        column_width: '315px',
                        class: '',
                    },
                    {
                        name: 'Type',
                        text_key: 'type',
                        value_key: 'type',
                        column_width: '120px',
                        class: ''
                    },
                    {
                        name: 'Sent to',
                        text_key: 'sent_to',
                        value_key: 'sent_to',
                        column_width: '60px',
                        class: '',
                    },
                    {
                        name: 'Clicks',
                        text_key: 'clicks',
                        value_key: 'clicks',
                        column_width: '60px',
                        class: '',
                    },
                    {
                        name: 'External Link',
                        text_key: 'external_links',
                        type: 'component',
                        component: 'flag-links',
                        value_key: 'external_links',
                        column_width: '220px',
                        class: 'inline-flex whitespace-no-wrap',
                    },
                    {
                        name: 'Resend',
                        text_key: 'resend',
                        type: 'resend_button',
                        value_key: 'resend',
                        column_width: '100px',
                        class: '',
                    }
                ]
            }
        },

        content: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: `The Nordic Council's environmental award`,
                        thumbnail: '/storage/ad-manifest.png',
                        published: '11/11/2021 - 10:32:23',
                        topic: 'Environment and Climate',
                        sent_to: 1002,
                        clicks: 2,
                        external_links: [
                            {
                                language: 'da',
                                link: 'https://dr.dk/da'
                            },
                            {
                                language: 'no',
                                link: 'https://dr.dk/no'
                            },
                        ]
                    },
                ];
            }
        },
        selected_topic: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Topics'
                }
            }
        },

        dropdown_topics: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 0,
                        name: 'All Topics'
                    },
                    {
                        id: 1,
                        name: 'Countries and Regions',
                    },
                    {
                        id: 2,
                        name: 'Culture, Leisure and Media',
                    },
                    {
                        id: 3,
                        name: 'Legislation and Justice',
                    },
                    {
                        id: 4,
                        name: 'Environment and Climate',
                    },
                    {
                        id: 5,
                        name: 'The Nordic Region and the Surrounding World'
                    },
                    {
                        id: 6,
                        name: 'Education and Research'
                    },
                    {
                        id: 7,
                        name: 'Welfare and Gender Equality'
                    },
                    {
                        id: 8,
                        name: 'Economy, Business and Working Life'
                    },
                    {
                        id: 9,
                        name: 'Nordic Council prizes'
                    },
                    {
                        id: 10,
                        name: 'Nordic Council sessions'
                    }

                ]

            },


        },

    },

    methods: {

        handle_click_on_external_link() {

            this.$inertia.visit( this.route('campaign_rule') );

        },



        handle_flag_clicked(link) {

            window.open(link, '_blank');

        },


        handle_click_dropdown(field, choice) {

            let
                parameters = this.route().params
            ;

            parameters[field] = choice.id

            this.$inertia.visit(
                this.route('events', parameters)
            );

        },

    }

})
</script>


